module.exports = __webpack_public_path__ + "static/media/joao_vitor.ecd08879.jpg";